export default "__VITE_ASSET__BM45aL8f__"